
// import oArticleHero from '../organisms/article/ArticleHero.vue';

export default {
    name: 't-article',
};
